/**
 * Webflow Dev Setup - Main Entry Point
 * 
 * Basis-Libs (immer geladen):
 * - Lenis (Smooth Scroll)
 * - GSAP (Animation)
 * 
 * Module werden nur initialisiert wenn data-module="..." im DOM existiert.
 * In Webflow einfach das Attribut zum Element hinzufügen:
 * 
 * <div data-module="tabs">...</div>
 * <div data-module="accordion">...</div>
 * <div data-module="logo-wall">...</div>
 * <video data-module="lazy-video" data-snippet-src="...">...</video>
 * <div data-module="bunny-lightbox">...</div>
 * <div data-module="table-of-contents" data-toc-wrap>...</div>
 * <div data-module="baustein" data-baustein="vergleichstabelle">...</div>
 *
 * Ausnahme ohne data-module: Bilder mit data-parallax="scroll" | "zoom"
 * starten das Parallax-Modul von selbst.
 */

// Basis-Libs (immer geladen)
import { Scroll } from "@lib/scroll";

// Tick-Utility nur in der DEV-Umgebung laden (Performance-Optimierung)
if (process.env.NODE_ENV !== "production") {
  import("@/utils/tick");
}


// Module (werden nur initialisiert wenn Element existiert)
import { initTabs } from "@/modules/components/tabs";
import { initAccordion } from "@/modules/components/accordion";
import { initLogoWallCycle } from "@/modules/components/logo-wall-cycle";
import { initLazyVideos } from "@/modules/components/lazy-video";
import { initBunnyLightboxPlayer, initBunnyLightboxTrigger } from "@/modules/components/bunny-lightbox.js";
import { initFormsparkForms } from "@/modules/components/formspark-form.js";
import { initStickyStepsBasic } from "@/modules/components/sticky-steps.js";
import { initTableOfContents } from "@/modules/components/table-of-contents.js";
import { initBausteine } from "@/modules/bausteine";
import { initParallax } from "@/modules/components/parallax";

// Module Registry
const modules: Record<string, () => void> = {
  "tabs": initTabs,
  "accordion": initAccordion,
  "logo-wall": initLogoWallCycle,
  "lazy-video": initLazyVideos,
  "bunny-lightbox": () => {
    initBunnyLightboxPlayer();
    initBunnyLightboxTrigger();
  },
  "formspark-form": initFormsparkForms,
  "sticky-steps": initStickyStepsBasic,
  "table-of-contents": initTableOfContents,
  "baustein": initBausteine,
};

// Track welche Module schon initialisiert wurden
const initializedModules = new Set<string>();

function initModules() {
  const elements = document.querySelectorAll<HTMLElement>("[data-module]");
  const needed = new Set<string>();
  
  elements.forEach(el => {
    const name = el.dataset.module;
    if (name && !initializedModules.has(name)) {
      needed.add(name);
    }
  });

  needed.forEach(name => {
    const initFn = modules[name];
    if (initFn) {
      initializedModules.add(name);
      initFn();
      console.log(`[Module] ✓ ${name}`);
    } else {
      console.warn(`[Module] "${name}" nicht gefunden. Verfügbar: ${Object.keys(modules).join(", ")}`);
    }
  });
}

class _App {
  private scroll = Scroll;

  constructor() {
    console.log("🚀 BUNNY NEW App gestartet - v0.2.0");

    

    initModules();

    if (document.querySelector("[data-parallax]")) {
      initParallax();
      console.log("[Module] ✓ parallax");
    }
    }
  }


export const App = new _App();
